export abstract class BaseException extends Error {
  public abstract getError(): string;

  constructor(
    public readonly message: string,
    public readonly extraData?: string | object,
  ) {
    super(message);
  }

  toString(): string {
    if(this.extraData) {
      return `${this.getError()}:${this.message}:${JSON.stringify(this.extraData, null, 2)}`;
    }
    else {
      return `${this.getError()}:${this.message}`;
    }
  }
}
